<template>
    <div
        :class="{large: large, small: !large}"
        class="function-menu"
    >
        <div class="menu-action-links">
            <ul
                v-if="large"
                class="menu align-right align-middle"
            >
                <basket-element
                    :basket-link="options.BasketLink"
                    :basket-count="options.BasketCount"
                    :options="options"
                    :website-type="websiteType"
                    :classes="{large: large, small: !large}"
                    class="padding-right"
                />

                <search-element
                    v-if="options.EnableSearch"
                    :classes="classes"
                    class="padding-right"
                />

                <name-element
                    :is-authenticated="options.IsAuthenticated"
                    :user-name="options.UserName"
                    :classes="{large: large, small: !large}"
                    class="padding-right"
                />

                <login-logout-element
                    :is-authenticated="options.IsAuthenticated"
                    :user-name="options.UserName"
                    :classes="{large: large, small: !large}"
                    :my-page-link="options.MyPageLink"
                    :logout-link="options.LogoutLink"
                    :my-page-text="options.MyPageMobileText"
                    :is-large="large"
                />
            </ul>
            <ul
                v-if="!large"
                class="menu align-right align-middle padding-top-mobile"
            >
                <login-logout-element

                    :is-authenticated="options.IsAuthenticated"
                    :user-name="options.UserName"
                    :classes="{large: large, small: !large}"
                    :my-page-link="options.MyPageLink"
                    :logout-link="options.LogoutLink"
                    :my-page-text="options.MyPageMobileText"
                    :is-large="large"
                    class="padding-right-mobile"
                />
                <basket-element
                    :basket-link="options.BasketLink"
                    :basket-count="options.BasketCount"
                    :options="options"
                    :website-type="websiteType"
                    :classes="{large: large, small: !large}"
                    class="padding-right-mobile"
                />
                <burger-element
                    :classes="classes"
                />
            </ul>
        </div>
    </div>
</template>
<script>
import BasketElementVue from './FunctionMenu/BasketElement.vue';
import BurgerElement from './FunctionMenu/BurgerElement.vue';
import HeaderBaseMixinVue from './HeaderBaseMixin.vue';
import LoginLogoutElement from './FunctionMenu/LoginLogoutElement.vue';
import NameElementVue from './FunctionMenu/NameElement.vue';
import SearchElement from './FunctionMenu/SearchIconElement.vue';

export default {
    name: 'FunctionMenu',
    components: {
        'basket-element': BasketElementVue,
        'name-element': NameElementVue,
        'login-logout-element': LoginLogoutElement,
        'burger-element': BurgerElement,
        'search-element': SearchElement
    },
    mixins: [
        HeaderBaseMixinVue
    ],
    props: {
        options: {
            type: Object,
            default() {
                return {};
            }
        }
    },
    computed: {
        classes() {
            return {
                large: this.large,
                small: !this.large
            };
        }
    },
    methods: {
        showMoblieMenu() {
            this.$store.commit('header/toggleMobileMenu');
        }
    }
};
</script>
<style lang="scss" scoped>
@import 'header';
.function-menu {
    &.large {
        .padding-lr {
            padding: 0 rem-calc(15px);
        }

        .no-top-bottom-padding {
            padding: 0 rem-calc(10.5px);
        }

        .function-menu {
            line-height: $menu-line-height;
        }
    }

    &.small {
        .padding-lr {
            padding: 0 rem-calc(15px);
        }

        .no-top-bottom-padding {
            padding: 0 rem-calc(13px);
        }

        .function-menu {
            line-height: $menu-line-height;
        }
    }

    .padding-right {
        padding-right: $function-menu-icon-spacing;
    }

    .padding-top {
        padding-top: $function-menu-icon-padding-top;
    }

    .padding-right-mobile {
        padding-right: $function-menu-icon-spacing-mobile;
    }
    .padding-top-mobile {
        padding-top: $function-menu-icon-padding-top-mobile;
    }
}

</style>
